var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discussPage"},[_c('h2',{staticClass:"house-page-title titleStyle"},[_vm._v("买房讨论群")]),_c('a',{staticClass:"aStyle",on:{"click":_vm.goDetail}})])}
var staticRenderFns = []

export { render, staticRenderFns }